
{
    "optionsLanguageList": [
        {     "value": "EN",     "label": "options.languagelist.english" },
        {     "value": "ES",     "label": "options.languagelist.español" },
        {     "value": "FR",     "label": "options.languagelist.français" },
        {     "value": "DE",     "label": "options.languagelist.deutsch" },
        {     "value": "PT",     "label": "options.languagelist.português" },
        {     "value": "AR",     "label": "options.languagelist.arabic" },
        {     "value": "SW",     "label": "options.languagelist.swahili" },
        {     "value": "TH",     "label": "options.languagelist.thai" },
        {     "value": "RU",     "label": "options.languagelist.russian" },
        {     "value": "ZH",     "label": "options.languagelist.chinese" }

    ],
    "optionsCopyrightCategories": [
        { "value": 1,   "label": "options.copyrightCategories.literaryAuthorsAndResearchers" , "isBold": true },
        { "value": 2,   "label": "options.copyrightCategories.writersNovelistsPoets" },
        { "value": 3,   "label": "options.copyrightCategories.journalists" },
        { "value": 4,   "label": "options.copyrightCategories.lyricists" },
        { "value": 5,   "label": "options.copyrightCategories.authorsOfTextbooksAndDictionaries" },
        { "value": 6,   "label": "options.copyrightCategories.researchersAndAuthorsOfAcademicStudies" },
        { "value": 7,   "label": "options.copyrightCategories.digitalCreatorsSoftware" },
        { "value": 8,   "label": "options.copyrightCategories.softwareAndApplicationProgrammers" },
        { "value": 9,   "label": "options.copyrightCategories.digitalAndInteractiveGameDesigners" },
        { "value": 10,  "label": "options.copyrightCategories.authorsOfDatabasesAndDigitalPlatforms" },
        { "value": 11,  "label": "options.copyrightCategories.authorsOfInteractiveStoriesAndNarrativeGames" },
        { "value": 12,  "label": "options.copyrightCategories.digitalContentCreators" },
        { "value": 13,  "label": "options.copyrightCategories.youTubersPodcastersStreamers" },
        { "value": 14,  "label": "options.copyrightCategories.bloggersEArticleWriters" },
        { "value": 15,  "label": "options.copyrightCategories.shortFormVideoCreatorsAndDigitalAds" },
        { "value": 16,  "label": "options.copyrightCategories.aiAndVirtualRealityCreators" },
        { "value": 17,  "label": "options.copyrightCategories.vrArDesigners" },
        { "value": 18,  "label": "options.copyrightCategories.authorsOfCreativeAlgorithmsAndIntelligentRobots" },
        { "value": 19,  "label": "options.copyrightCategories.translatorsAndContentEditors" },
        { "value": 20,  "label": "options.copyrightCategories.literaryAndTechnicalTranslators" },
        { "value": 21,  "label": "options.copyrightCategories.subtitlersDubbingAdapters" },
        { "value": 22,  "label": "options.copyrightCategories.proofreadersLanguageEditors" },
        { "value": 23,  "label": "options.copyrightCategories.artisansAndCreatorsOfTraditionalArt" },
        { "value": 24,  "label": "options.copyrightCategories.traditionalCraftsmenSculptureOrnamentationMosaicMiniature" },
        { "value": 25,  "label": "options.copyrightCategories.authorsOfHeritageDesignsAndTraditionalClothing" },
        { "value": 26,  "label": "options.copyrightCategories.calligraphersAndCreatorsOfTypographicWorks" },
        { "value": 27,  "label": "options.copyrightCategories.visualArtistsDesigners" },
        { "value": 28,  "label": "options.copyrightCategories.designersPhotographers" },
        { "value": 29,  "label": "options.copyrightCategories.authorsOfTheBeauxArts" },
        { "value": 30,  "label": "options.copyrightCategories.graphicDesignersComputerGraphicsDesigners" },
        { "value": 31,  "label": "options.copyrightCategories.architects" },
        { "value": 32,  "label": "options.copyrightCategories.authorAndComposersArranger" },
        { "value": 33,  "label": "options.copyrightCategories.composers" },
        { "value": 34,  "label": "options.copyrightCategories.lyricists" },
        { "value": 35,  "label": "options.copyrightCategories.arrangers" },
        { "value": 36,  "label": "options.copyrightCategories.publisher" },
        { "value": 37,  "label": "options.copyrightCategories.creatorsOfDramaticAndDramaticoMusicalWorks" },
        { "value": 38,  "label": "options.copyrightCategories.plays" },
        { "value": 39,  "label": "options.copyrightCategories.musicalDramaShows" },
        { "value": 40,  "label": "options.copyrightCategories.dramaticAndMusicalDramasPerformedInPublicOrBroadcast" },
        { "value": 41,  "label": "options.copyrightCategories.audiovisualAndFilmCreators" },
        { "value": 42,  "label": "options.copyrightCategories.directors" },
        { "value": 43,  "label": "options.copyrightCategories.screenwritersDialogueWriters" },
        { "value": 44,  "label": "options.copyrightCategories.cinematographers" },
        { "value": 45,  "label": "options.copyrightCategories.productionDesignersScenographers" },
        { "value": 46,  "label": "options.copyrightCategories.costumers" },
        { "value": 47,  "label": "options.copyrightCategories.thoseWhoAppearInBroadcastLiteraryWorksSuchAsProgramsReportsDocumentaries" },
        { "value": 48,  "label": "options.copyrightCategories.radioAndTelevisionBroadcasts" },
        { "value": 49,  "label": "options.copyrightCategories.reports" },
        { "value": 50,  "label": "options.copyrightCategories.documentaryFilms" },
        { "value": 51,  "label": "options.copyrightCategories.visualArtists" },
        { "value": 52,  "label": "options.copyrightCategories.painters" },
        { "value": 53,  "label": "options.copyrightCategories.sculptors" },
        { "value": 54,  "label": "options.copyrightCategories.photographers" },
        { "value": 55,  "label": "options.copyrightCategories.digitalArtists" },
        { "value": 56,  "label": "options.copyrightCategories.other" }
    ],
    "optionsRelatedCategories": [
        {     "value": 1,     "label": "options.relatedCopyrightCategories.holders_of_neighbouring_rights" },
        {     "value": 2,     "label": "options.relatedCopyrightCategories.singer" },
        {     "value": 3,     "label": "options.relatedCopyrightCategories.musician" },
        {     "value": 4,     "label": "options.relatedCopyrightCategories.actor" },
        {     "value": 5,     "label": "options.relatedCopyrightCategories.dancer" },
        {     "value": 6,     "label": "options.relatedCopyrightCategories.reciter" },
        {     "value": 7,     "label": "options.relatedCopyrightCategories.producer" },
        {     "value": 8,     "label": "options.relatedCopyrightCategories.sound_broadcasting_organization" },
        {     "value": 9,     "label": "options.relatedCopyrightCategories.audiovisual_broadcasting_organization" },
        {     "value": 10,    "label": "options.relatedCopyrightCategories.other" }
    ],
    "caseOutcomeOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.caseOutcomeVal.pending" },
        {     "value": 2,     "label": "options.caseOutcomeVal.completeReq" },
        {     "value": 3,     "label": "options.caseOutcomeVal.Settled" },
        {     "value": 4,     "label": "options.caseOutcomeVal.inactive" },
        {     "value": 5,     "label": "options.caseOutcomeVal.archived" },
        {     "value": 6,     "label": "options.caseOutcomeVal.expired" },
        {     "value": 7,     "label": "options.caseOutcomeVal.joinder" },
        {     "value": 8,     "label": "options.caseOutcomeVal.dismissed" },
        {     "value": 9,     "label": "options.caseOutcomeVal.notAmended" },
        {     "value": 10,    "label": "options.caseOutcomeVal.other" }
    ],

     "DIPcaseOutcomeOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.DIPcaseOutcomeVal.pending" },
        {     "value": 2,     "label": "options.DIPcaseOutcomeVal.holding" },
        {     "value": 3,     "label": "options.DIPcaseOutcomeVal.settled" },
        {     "value": 4,     "label": "options.DIPcaseOutcomeVal.unsettled" },
        {     "value": 5,     "label": "options.DIPcaseOutcomeVal.req_party_withdraw" },
        {     "value": 6,     "label": "options.DIPcaseOutcomeVal.unable_req_party" },
        {     "value": 7,     "label": "options.DIPcaseOutcomeVal.unable_resp_party" },
        {     "value": 8,     "label": "options.DIPcaseOutcomeVal.resp_party_within_period" },
        {     "value": 9,     "label": "options.DIPcaseOutcomeVal.resp_party_mediation_process" },
        {     "value": 10,     "label": "options.DIPcaseOutcomeVal.all_party_terminate_process" },
        {     "value": 11,    "label": "options.DIPcaseOutcomeVal.other" }
    ],
  
    "typeOfDisputeOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.typeOfDispute.rPayment" },
        {     "value": 2,     "label": "options.typeOfDispute.bContract" },
        {     "value": 3,     "label": "options.typeOfDispute.rights" },
        {     "value": 4,     "label": "options.typeOfDispute.image" },
        {     "value": 5,     "label": "options.typeOfDispute.useRights" },
        {     "value": 6,     "label": "options.typeOfDispute.infringement" },
        {     "value": 7,     "label": "options.typeOfDispute.cultures" },
        {     "value": 8,     "label": "options.typeOfDispute.other" }
    ],

    "DIP_typeOfDisputeOptions": [
        {     "value": 8,    "label": "options.DIP_typeOfDispute.other" },
        {     "value": 9,    "label": "options.DIP_typeOfDispute.copyright" },
        {     "value": 10,   "label": "options.DIP_typeOfDispute.trademarksOrServiceMarks" },
        {     "value": 11,   "label": "options.DIP_typeOfDispute.inventionPatent" },
        {     "value": 12,   "label": "options.DIP_typeOfDispute.pettyPatent" },
        {     "value": 13,   "label": "options.DIP_typeOfDispute.productDesignPatent" }
    ],

    "attendanceOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.attendance.attended" },
        {     "value": 2,     "label": "options.attendance.notAttended" }
    ],
    
    "enforcementOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.enforcement.agreement" },
        {     "value": 2,     "label": "options.enforcement.judgment" }
    ],

    "typeOfPartyOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.typeOfParty.individual" },
        {     "value": 2,     "label": "options.typeOfParty.company" },
        {     "value": 3,     "label": "options.typeOfParty.CMO" },
        {     "value": 4,     "label": "options.typeOfParty.softwarecompany" },
        {     "value": 5,     "label": "options.typeOfParty.Other" }
    ],

    "genderOptions": [
        {     "value": 0,     "label": "common.selectoptionLable" },
        {     "value": 1,     "label": "options.gender.female" },
        {     "value": 2,     "label": "options.gender.male" },
        {     "value": 3,     "label": "options.gender.Other" }
    ],

        "questions": [
        {     "value": true,     "label": "options.question.yes" },
        {     "value": false,     "label": "options.question.no" }
    ],

    "audienceModalityOptions": [
        {     "value": 1,     "label": "options.audienceModality.presencial" },
        {     "value": 2,     "label": "options.audienceModality.telematica" }
    ],

    "notificationModalityOptions": [
        {     "value": 1,     "label": "options.notificationModality.fisica" },
        {     "value": 2,     "label": "options.notificationModality.electronica" }
    ]
}
    